module.exports = __webpack_public_path__ + "img/Seagull.1a7ffa2c.jpeg";